import { memo } from 'react';

import TimeSlotField from '../../../common/fields/TimeSlotField';
import SectionCard from './SectionCard';

export default memo(function TimeSlotsSection({
  timeSlots,
  setTimeSlots,
  subjectOptions,
  mediumOptions,
  cityOptions,
  classTypeOptions,
  selectedSubjects,
  selectedMedium,
  selectedCities,
  selectedClassTypes,
}) {
  const filteredSubjects = subjectOptions.filter((s) => selectedSubjects?.includes(s.id));
  const filteredMedium = mediumOptions.filter((m) => selectedMedium?.includes(m.id));
  const filteredCities = cityOptions.filter((c) => selectedCities?.includes(c.id));
  const filteredClassTypes = classTypeOptions.filter((t) => selectedClassTypes?.includes(t.id));
  return (
    <SectionCard title="Time Slots">
      <TimeSlotField
        label=""
        timeSlots={timeSlots}
        setTimeSlots={setTimeSlots}
        subjects={filteredSubjects.length ? filteredSubjects : subjectOptions}
        medium={filteredMedium.length ? filteredMedium : mediumOptions}
        cities={filteredCities.length ? filteredCities : cityOptions}
        classTypes={filteredClassTypes.length ? filteredClassTypes : classTypeOptions}
      />
    </SectionCard>
  );
});
